import Vue from "vue";
import { mapGetters } from "vuex";
import { LoadingSpinner } from "@/components";
import { ErrorLogService, PromotionService } from "@/services/";
import { WysiwygHtmlArea } from "@/components/Elements/WysiwygHtmlArea"


export default Vue.extend({
    name: "Promotion",
    components: {
        LoadingSpinner,
        WysiwygHtmlArea
    },
    created() {
        this.promotionId = this.$route.query.id;
        this.getPromotion();
    },
    computed: {
        ...mapGetters(["user", "getContentItem"]),
    },
    data: () => ({
        promotion: {},
        promotionId: 0,
        isLoadingPromotion: false
    }),
    methods: {
        async getPromotion() {
            this.isLoadingPromotion = true;
            try {
                let result = await PromotionService.getPromotion(this.promotionId);
                this.promotion = result;
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isLoadingPromotion = false;
            }
        }
    },
    watch: {},
});